module.exports = __webpack_public_path__ + "media/images/covers/Foundation-Open-Day-Banner-d02fb169798e59c3c715b409386c3ec4.png";